import styled from "styled-components";

const StyledButton = styled.button`
  border: none;
  cursor: pointer;
  width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};

  &:focus:not([data-focus-visible-added]) {
    outline: none;
  }
`;

const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

export { StyledButton, StyledLink };
